/**
 * Sistema de rangos espartanos (seccion 9.1).
 *
 * Umbrales calibrados para 6 quincenas por temporada con 3–5 competiciones
 * cada una. Son la mitad que cuando las competiciones eran semanales: con la
 * mitad de rondas se reparte la mitad de puntos, y el ritmo de subida se
 * mantiene.
 *
 * Espejo de supabase/functions/_shared/ranks.ts, que usan las funciones del
 * servidor. Si cambias uno, cambia el otro: el test del catalogo lo comprueba.
 */

export interface RankDefinition {
  level: number;
  /** Clave de traduccion: `rank.<code>` en es.json / en.json (RF-LANG-03). */
  code: string;
  minPoints: number;
  /** Puntos maximos del rango; `null` en el ultimo. */
  maxPoints: number | null;
  /** Color del marco del escudo. */
  frame: 'bronze-dim' | 'bronze' | 'iron' | 'silver' | 'silver-gold' | 'gold' | 'gold-ember';
}

export const RANKS: RankDefinition[] = [
  { level: 1, code: 'recruit', minPoints: 0, maxPoints: 124, frame: 'bronze-dim' },
  { level: 2, code: 'ephebe', minPoints: 125, maxPoints: 374, frame: 'bronze' },
  { level: 3, code: 'hoplite', minPoints: 375, maxPoints: 874, frame: 'iron' },
  { level: 4, code: 'enomotarch', minPoints: 875, maxPoints: 1624, frame: 'silver' },
  { level: 5, code: 'lochagos', minPoints: 1625, maxPoints: 2499, frame: 'silver-gold' },
  { level: 6, code: 'polemarch', minPoints: 2500, maxPoints: 3499, frame: 'gold' },
  { level: 7, code: 'spartan_king', minPoints: 3500, maxPoints: null, frame: 'gold-ember' },
];

/** Colores de cada marco de escudo, resueltos a CSS en RankShield. */
export const RANK_FRAME_COLORS: Record<RankDefinition['frame'], { stroke: string; glow: string }> = {
  'bronze-dim': { stroke: '#6B4A2B', glow: 'transparent' },
  bronze: { stroke: '#8C6239', glow: 'rgb(140 98 57 / 0.35)' },
  iron: { stroke: '#6E7379', glow: 'rgb(110 115 121 / 0.35)' },
  silver: { stroke: '#B9C0C7', glow: 'rgb(185 192 199 / 0.4)' },
  'silver-gold': { stroke: '#CFC08A', glow: 'rgb(207 192 138 / 0.45)' },
  gold: { stroke: '#D4AF37', glow: 'rgb(212 175 55 / 0.5)' },
  'gold-ember': { stroke: '#F2D479', glow: 'rgb(242 212 121 / 0.65)' },
};
